'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require('react');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactHyperscript = require('react-hyperscript');

var _reactHyperscript2 = _interopRequireDefault(_reactHyperscript);

var _immutabilityHelper = require('immutability-helper');

var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _reactStripeElements = require('react-stripe-elements');

var _config2 = require('../utils/config');

var _tree = require('../utils/tree');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var SECRET_KEY = 'secretKey';
var PUBLISHABLE_KEY = 'publishableKey';
var schema = {
  id: 'stripe',
  name: 'Stripe',
  keys: {
    PUBLISHABLE_KEY: PUBLISHABLE_KEY,
    SECRET_KEY: SECRET_KEY
  },
  requiredKeys: [PUBLISHABLE_KEY],
  spec: [{
    key: PUBLISHABLE_KEY,
    value: ''
  }, {
    key: SECRET_KEY,
    private: true,
    value: ''
  }]
};

var publishableKey = function publishableKey(config) {
  return (0, _config2.getValueForIntegration)(config, schema.id, PUBLISHABLE_KEY);
};

var hasIntegration = function hasIntegration(config) {
  return !_lodash2.default.isEmpty(publishableKey(config));
}; // input elements with these ids will replaced with stripe elements


var stripeElementsLookUpTable = {
  'card-cvc': _reactStripeElements.CardCVCElement,
  'card-expiry': _reactStripeElements.CardExpiryElement,
  'card-number': _reactStripeElements.CardNumberElement,
  'card-postal-code': _reactStripeElements.PostalCodeElement
}; // inputs with these names will be sent to stripe along with card data

var stripeCardKeys = ['address_city', 'address_country', 'address_line1', 'address_line2', 'address_state', 'address_zip', 'country', 'name'];

function injected(WrappedComponent) {
  return (0, _reactStripeElements.injectStripe)(function (props) {
    var config = _extends({}, props.config);

    _lodash2.default.forEach(_lodash2.default.keys(config.data), function (configKey) {
      var _config = config,
          tree = _config.data[configKey].tree;

      var nextTree = _extends({}, tree); // first we replace any stripe inputs with their react-stripe-elements analog


      var forms = (0, _tree.searchTree)(tree, {
        p: {
          name: 'stripe'
        },
        tag: 'form'
      });

      _lodash2.default.forEach(forms, function (form) {
        _lodash2.default.forEach(stripeElementsLookUpTable, function (element, id) {
          var input = _lodash2.default.first((0, _tree.searchTree)(form.c, {
            p: {
              name: _lodash2.default.camelCase(id)
            }
          }, form.path));

          if (input) {
            nextTree = (0, _tree.replaceNodeInTree)(nextTree, _extends({}, input, {
              tag: element
            }));
          }
        });

        var buttons = (0, _tree.searchTree)(form.c, {
          p: {
            _function: 'stripe:createToken'
          }
        }, form.path);

        _lodash2.default.forEach(buttons, function (button) {
          nextTree = (0, _tree.setPropOnNodeInTree)(nextTree, button.path, '_function', 'submitForm'); // let form handler submit this, we'll use willSendData to transform it into a token
        });
      });

      config = (0, _immutabilityHelper2.default)(config, {
        data: _defineProperty({}, configKey, {
          tree: {
            $set: nextTree
          }
        })
      });
    });

    var willSendData = function willSendData(form, name) {
      if (name === 'stripe') {
        // this integration will only process forms named stripe
        return props.stripe.createToken(_lodash2.default.pick(form.data, stripeCardKeys)).then(function (_ref) {
          var token = _ref.token;
          var nextForm = (0, _immutabilityHelper2.default)(form, {
            data: {
              $merge: {
                stripeToken: token.id
              }
            }
          });

          if (_lodash2.default.isFunction(props.willSendData)) {
            return props.willSendData(nextForm, name);
          }

          return nextForm;
        });
      } // if it's not named stripe, still must call ownProps.willSendData


      if (_lodash2.default.isFunction(props.willSendData)) {
        return props.willSendData(form, name);
      }

      return form;
    };

    return (0, _reactHyperscript2.default)(WrappedComponent, _extends({}, props, {
      config: config,
      willSendData: willSendData
    }));
  });
}

function withStripe(WrappedComponent) {
  var WithStripe = function (_Component) {
    _inherits(WithStripe, _Component);

    function WithStripe() {
      _classCallCheck(this, WithStripe);

      return _possibleConstructorReturn(this, (WithStripe.__proto__ || Object.getPrototypeOf(WithStripe)).apply(this, arguments));
    }

    _createClass(WithStripe, [{
      key: 'render',
      value: function render() {
        if (!hasIntegration(this.props.config)) {
          // technically we shouldn't ever get here if they don't have the integration
          // but react seems to do some weird stuff with cacheing imports so it seems we do
          return (0, _reactHyperscript2.default)(WrappedComponent, this.props);
        }

        return (0, _reactHyperscript2.default)(_reactStripeElements.StripeProvider, {
          apiKey: publishableKey(this.props.config)
        }, [(0, _reactHyperscript2.default)(_reactStripeElements.Elements, {
          id: 'stripe-' + this.props.config.componentId
        }, [(0, _reactHyperscript2.default)(injected(WrappedComponent), this.props)])]);
      }
    }]);

    return WithStripe;
  }(_react.Component);

  WithStripe.propTypes = {
    config: _propTypes2.default.shape({
      componentId: _propTypes2.default.string,
      default: _propTypes2.default.object
    }).isRequired
  };
  return WithStripe;
}

exports.default = {
  apply: withStripe,
  hasIntegration: hasIntegration,
  schema: schema
};